import { Therapy } from './therapy.model';

export class Specialty {
  public category: string;
  public name: string;
  public therapies: Therapy[];

  constructor(category: string, name: string, therapies: Therapy[]) {
    this.category = category;
    this.name = name;
    this.therapies = therapies;
  }

  public static mapFromFirestore(specialty: any): Specialty {
    return new Specialty(
      specialty.category,
      specialty.name,
      Therapy.mapArrayFromFirestore(specialty.therapies)
    );
  }

  public mapToFirestore(): any {
    return {
      category: this.category,
      name: this.name,
      therapies: Therapy.mapArrayToFirestore(this.therapies)
    };
  }

  public static mapArrayFromFirestore(specialties: any[]): Specialty[] {
    var specialtiesArray: Specialty[] = [];
    specialties.forEach((specialty: any) => {
      specialtiesArray.push(Specialty.mapFromFirestore(specialty));
    });
    return specialtiesArray;
  }

  public static mapArrayToFirestore(specialties: Specialty[]): any {
    var specialtiesArray: Specialty[] = [];
    specialties.forEach((specialty: Specialty) => {
      specialtiesArray.push(specialty.mapToFirestore());
    });
    return specialtiesArray;
  }
}
